
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-toilets",
      function () {
        return require("private-next-pages/smart-toilets.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-toilets"])
      });
    }
  